import { CatalogCategory } from './catalog-categories';

const PIECE_NPM_SCOPE = '@activepieces/';
const NPM_SCOPE_PREFIX = '@';

export const SEARCH_QUERY_PARAM = 'q';
export const CATEGORY_QUERY_PARAM = 'category';

export const catalogCategorySearch = (category: CatalogCategory): string =>
  `?${new URLSearchParams({ [CATEGORY_QUERY_PARAM]: category })}`;

// Every catalogue piece lives under @activepieces/; dropping the scope keeps
// detail URLs readable (/catalog/piece-gmail).
export const pieceRouteParam = (pieceName: string): string =>
  pieceName.startsWith(PIECE_NPM_SCOPE)
    ? pieceName.slice(PIECE_NPM_SCOPE.length)
    : pieceName;

export const pieceNameFromRouteParam = (param: string): string =>
  param.startsWith(NPM_SCOPE_PREFIX) ? param : `${PIECE_NPM_SCOPE}${param}`;

export type CatalogLinkState = {
  catalogSearch: string;
};

export const catalogLinkState = (search: string): CatalogLinkState => ({
  catalogSearch: search,
});

// Router state is untyped and absent on a direct visit.
export const catalogSearchFrom = (state: unknown): string => {
  const { catalogSearch } = (state ?? {}) as { catalogSearch?: unknown };

  return typeof catalogSearch === 'string' ? catalogSearch : '';
};
